import {
  APPLICATION_INITIALIZATION_FAILED,
  APPLICATION_INITIALIZED,
} from './actions';

export const NOT_INITIALIZED = 'NOT_INITIALIZED';
export const INITIALIZED = 'INITIALIZED';
export const INITIALIZATION_FAILED = 'INITIALIZATION_FAILED';

const initialState = {
  applicationState: NOT_INITIALIZED,
};

const reducer = (state = initialState, action) => {
  let { type } = action;
  switch (type) {
    case APPLICATION_INITIALIZED: {
      return {
        ...state,
        applicationState: INITIALIZED,
      };
    }
    case APPLICATION_INITIALIZATION_FAILED: {
      return {
        ...state,
        applicationState: INITIALIZATION_FAILED,
      };
    }
    default:
      return state;
  }
};

export { reducer };
